module.exports = __webpack_public_path__ + "static/media/cornelia-goeppel.cf13189e.jpg";